/**
 * Created by Bart Decorte
 * Date: 2019-08-25
 * Time: 20:03
 */
import Column from './Column';
import Matrix from '../pages/Entries/_partials/EntriesEditMatrix';

class MatrixColumn extends Column {
  constructor(params) {
    super(params);
    this.dirtyUnloadNotifier = params.dirtyUnloadNotifier;

    this.matrix = new Matrix({
      $root: this.$root,
      dirtyUnloadNotifier: this.dirtyUnloadNotifier,
      level: params.level + 1,
    });

    this.bindListeners();
  }

  bindListeners() {
    // just pass the events of matrix upward
    this.matrix.on('busy', (ev) => {
      this.emit('busy');
    });
    this.matrix.on('idle', (ev) => {
      this.emit('idle');
    });
  }
}

export default MatrixColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/MatrixColumn.js